import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {center} from '../../../../../../libs/shared/ui/src/styles/mixins';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {CellsContext} from '../../../../../store/panels/cells/context/cellsContext';
import {ViewerPanelId} from '../../../../../store/panels/panelStateBase';
import {ConversationHeaderSubject} from './conversationHeaderSubject';
import {ConversationPinnedActivitiesButton} from './conversationPinnedActivitiesButton';

/*
 * Props.
 */

interface ConversationSubjectWrapperProps {
  cellsContext: CellsContext;
  conversation: ConversationModel;
  onSubjectChange?: HandlerOf<string>;
  panelId: ViewerPanelId;
  isUserVisitor: boolean;
}

/*
 * Style.
 */

const StyledSubjectContainerDiv = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  overflow: visible;
  margin-left: 8px;
  padding-right: 0;
  margin-left: -7px;
  margin-right: -7px;
  height: 34px;
`;

const StyledConversationPinnedActivitiesButton = styled(ConversationPinnedActivitiesButton)`
  flex-shrink: 0;
  align-self: flex-start;

  /* Subject line-height. */
  height: 34px;
  ${center()};
`;

/*
 * Component.
 */

export const ConversationSubjectWrapper: FC<ConversationSubjectWrapperProps> = (props) => {
  const {cellsContext, conversation, panelId, onSubjectChange, isUserVisitor} = props;
  return (
    <StyledSubjectContainerDiv>
      <ConversationHeaderSubject
        key={conversation.id}
        cellsContext={cellsContext}
        conversation={conversation}
        onSubjectChange={onSubjectChange}
      />

      {maybeRenderPinnedActivitiesButton(conversation, cellsContext, panelId, isUserVisitor)}
    </StyledSubjectContainerDiv>
  );
};

function maybeRenderPinnedActivitiesButton(
  conversation: ConversationModel,
  cellsContext: CellsContext,
  panelId: ViewerPanelId,
  isUserVisitor?: boolean,
) {
  if (isUserVisitor) {
    return null;
  }
  return (
    <StyledConversationPinnedActivitiesButton
      conversation={conversation}
      teammateId={cellsContext.teammateId}
      panelId={panelId}
    />
  );
}
